
export default {
  sistema: {
    collapsed: false
  },
  filtrosGestaoJornada: {
    dataInicial: '',
    dataFinal: '',
    buscas: '',
    status: 'todos',
    exibir: 'T',
    ordem: 'motorista'
  },
  filtrosRelatorios: {
    clienteId: '0',
    veiculoId: '0',
    veiculoDescricao: '',
    dataInicial: '',
    horaInicial: '00:00',
    dataFinal: '',
    horaFinal: '23:59',
    relatorio: '0',
    buscaVeiculo: '',
    selecionada: '0',
    filtroVelocidade: '0',
    filtroVelocidadeMinima: '0',
    filtroVelocidadeMaxima: '0',
    desprezarVelocidade: '5',
    agruparPosicoes: '0',
    entrada: 'ignicao',
    entradaVelocidade: '0',
    obdIgnicao: 'todas',
    obdRpm: '0',
    obdTemperatura: '0',
    obdErro: 'todas',
    agrupar: 'N',
    formato: 'visualizacao'
  },
  filtrosCliente: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosFornecedor: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosTransportador: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosVeiculo: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosVendedor: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosProduto: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosServico: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosDepositoMovimento: {
    dataInicial: '',
    dataFinal: '',
    produtoId: '0',
    produtoNome: '',
    tipo: '0',
    depositoId: '0'
  },
  filtrosDepositoBalanco: {
    dataInicial: '',
    dataFinal: '',
    buscas: '',
    depositoId: '0'
  },
  filtrosFinanceiro: {
    dataInicial: '',
    dataFinal: '',
    busca: '',
    titularId: '0',
    titularTipo: '',
    titularNome: '',
    titular: '',
    exibir: 'todos',
    ordenarPor: 'vencimento',
    selecionada: '0'
  },
  filtrosFinanceiroContaCaixa: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosBanco: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosBancoMovimento: {
    dataInicial: '',
    dataFinal: '',
    busca: '',
    bancoId: '0',
    exibir: '0',
    ordenarPor: 'vencimento'
  },
  filtrosBancoBoleto: {
    dataInicial: '',
    dataFinal: '',
    busca: '',
    bancoId: '0',
    exibir: 'T',
    ordenarPor: 'vencimento'
  },
  filtrosCheque: {
    dataInicial: '',
    dataFinal: '',
    busca: '',
    titularId: '0',
    titularTipo: '',
    titularNome: '',
    titular: '',
    status: '0',
    ordenarPor: 'vencimento',
    selecionada: '0'
  },
  filtrosCompra: {
    dataInicial: '',
    dataFinal: '',
    fornecedorId: '0',
    fornecedorNome: '',
    numero: '0',
    status: '',
    selecionada: '0',
    selecionadaCompra: ''
  },
  filtrosCompraCotacao: {
    dataInicial: '',
    dataFinal: '',
    fornecedorId: '0',
    fornecedorNome: '',
    numero: '0',
    status: '',
    selecionada: '0',
    selecionadaCompra: ''
  },
  filtrosCompraOrdemCompra: {
    dataInicial: '',
    dataFinal: '',
    fornecedorId: '0',
    fornecedorNome: '',
    numero: '0',
    status: '',
    selecionada: '0',
    selecionadaCompra: ''
  },
  filtrosVenda: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  filtrosDevolucao: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  filtrosVendaServico: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  filtrosVendaComodato: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  filtrosNotaFiscal: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  //
  filtrosFormaPagamento: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosCodigoNcm: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosCidade: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosMotorista: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosEvento: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosEventoDisparado: {
    dataInicial: '',
    dataFinal: '',
    buscas: '',
    eventoId: '0',
    status: 'T'
  },
  user: {
    name: '',
    email: ''
  },
  token: ''
}



// WEBPACK FOOTER //
// ./src/vuex/state.js